import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { OrgSelectionComponent, OrgSelectionFieldComponent } from './org-selection.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [OrgSelectionFieldComponent, OrgSelectionComponent],
  imports: [CommonModule, FormsModule, MaterialsModule, TranslateModule, SearchModule],
  exports: [OrgSelectionFieldComponent],
})
export class OrgSelectionModule {}

export const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http);
